__turbopack_context__.v({
  "cart": "main-page-module__V94eSa__cart",
  "feed": "main-page-module__V94eSa__feed",
  "isMobile": "main-page-module__V94eSa__isMobile",
  "unavailable": "main-page-module__V94eSa__unavailable",
});
